import { BASE } from "../index";
import axios from "../http";

const BASE_URL = BASE.PRO1;
const BASE_URL2 = BASE.PRO2;

/**
 * 总控-自提点列表
 * @param {*} params
 * @returns
 */
export function postDeliveryListNew(params = {}) {
  return axios.post(`${BASE_URL}/delivery/list/new`, params);
}
/**
 * 集配-自提点列表
 * @param {*} params
 * @returns
 */
export function postcityDeliveryListNew(params = {}) {
  return axios.post(`${BASE_URL2}/delivery/list/page`, params);
}
/**
 * 集配-自提点列表切换按件
 * @param {*} params
 * @returns
 */
export function selfPurchasedelivery(params = {}) {
  return axios.post(`${BASE_URL2}/delivery/vehicle/update`, params);
}
/**
 * 集配-城市仓列表切换按件
 * @param {*} params
 * @returns
 */
export function logisticsvehicleupdate(params = {}) {
  return axios.post(`${BASE_URL2}/logistics/vehicle/update`, params);
}
/**
 * 集配-自提点列表切换按件
 * @param {*} params
 * @returns
 */
export function deliveryvehiclelog(params = {}) {
  return axios.post(`${BASE_URL2}/delivery/vehicle/log`, params);
}
